// extracted by mini-css-extract-plugin
export default {"item":"ClickedPreBuilt_item__e2+bI","img-container":"ClickedPreBuilt_img-container__KrWFp","item-details":"ClickedPreBuilt_item-details__WlF1L"};